import { Capacitor } from '@capacitor/core';

export const isIOS = (): boolean => {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
};

export const isAndroid = (): boolean => {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
};

export const isWeb = (): boolean => {
  return !Capacitor.isNativePlatform();
};

export const isNative = (): boolean => {
  return Capacitor.isNativePlatform();
};

export const getPlatform = (): 'ios' | 'android' | 'web' => {
  if (isIOS()) return 'ios';
  if (isAndroid()) return 'android';
  return 'web';
};

export const shouldUseWebPayments = (): boolean => {
  return isWeb();
};

export const shouldUseIOSPayments = (): boolean => {
  return isIOS();
};

export const shouldUseAndroidPayments = (): boolean => {
  return isAndroid();
};
